/* tslint:disable */

/**
 */
export class ShiftData {
}
